import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserProvider } from '../services';
import { SetIsNotificationRedirect } from '../services/storage-data.utility';
import { IsTokenExpired } from '../session-expiry';

/**
 * redirects to the login page, preserving the target url and the session-expired flag.
 */
function redirectToLogin(
  router: Router,
  url: string,
  sessionExpired = false,
): void {
  if (url.startsWith('/home/notifiche')) {
    SetIsNotificationRedirect(true);
  }

  router.navigate(['/'], {
    queryParams: sessionExpired
      ? { redirectTo: url, sessionExpired: true }
      : { redirectTo: url },
    replaceUrl: true,
  });
}

/**
 * blocks access to the login page when the user is already authenticated.
 * @returns {boolean} true if the route can be activated, false otherwise.
 */
export const alreadyLoggedCheckGuard: CanActivateFn = () => {
  const userProvider = inject(UserProvider);
  const router = inject(Router);

  if (userProvider.isAuthenticated()) {
    router.navigate(['/apps']);
    return false;
  }

  return true;
};

/**
 * blocks access when the user is not authenticated or the token is locally expired.
 * @returns {boolean} true if the route can be activated, false otherwise.
 */
export const authenticationGuard: CanActivateFn = (_route, state) => {
  const userProvider = inject(UserProvider);
  const router = inject(Router);

  if (!userProvider.isAuthenticated()) {
    redirectToLogin(router, state.url);
    return false;
  }

  if (IsTokenExpired()) {
    redirectToLogin(router, state.url, true);
    return false;
  }

  return true;
};
